
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import vuetifyToast from 'vuetify-toast';
import { Passenger } from '../models/Passenger';
import Destination from '../models/Destination';
import './PassengerEditor.scss'
import Group from '../models/Group';
import GroupPicker from "./GroupPicker.vue"
import { Utility } from '@/components/Passenger/models/Utility';

@Component({
    template: require("./PassengerEditor.vue.html"),
    components: {
        GroupPicker
    }
})
export class PassengerEditor extends Vue {

    static EVENT_PASSENGER_EDITOR_OPEN = "EVENT_PASSENGER_EDITOR_OPEN";
    public static NEW_GROUP_CREATOR_ITEM: string = "- New tag -";

    show: boolean = false;
    editedPassenger: Passenger = new Passenger(null);
    valid: boolean = true;
    saving: boolean = false;
    rules: any = {
      required: value => !!value 
        || this.$i18n.translate("validation.rules.required", "Required")
    }
 
    get utilities() {
        const utilityOptions = Passenger.utilities.map(u => new Utility(u.id, u.title));
        utilityOptions.forEach(u => u.selected = this.editedPassenger.utilityIds.includes(u.id));
        return utilityOptions;        
    }

    utilityIconImageSrc(utilityId: number): string{
        const imageBasePath = '/frontend/utilities/';
        if (utilityId === 2){
            return imageBasePath + 'man-waving-arm-32' + '.png';
        } else {
            return imageBasePath + 'utility' + utilityId + '.png';
        }
    }

    utilityTitle(utilityId: number): string{
        const utility: Utility = Passenger.utilities.find((u: any) => u.id === utilityId);
        return utility 
            ? this.$i18n.translate("utility.title." + utility.title, utility.title) 
            : "Unknown utility";
    }

    created(){
        this.$root.$on(PassengerEditor.EVENT_PASSENGER_EDITOR_OPEN, this.onShowPassengerEditor)
    }

    onUtilityClick(utilityId: number) {
        this.editedPassenger.toggleUtility(utilityId);
    }
           
    async onSaveClick() {
        this.saving = true;
        // TODO: Get rid of casting to any
        if ((this.$refs.form as any).validate()) {
            
            try {
                if (this.editedPassenger.id > 0) {
                // console.log("save, update existing: ", this.editedPassenger);
                    await this.$store.dispatch('passenger/updatePassenger', 
                        { params: { id: this.editedPassenger.id}, data: this.editedPassenger });
                } else {
                    (this.editedPassenger as any).destinationIds = this.editedPassenger
                        .passengerDestinations.map(pd => pd.destinationId);
                    // console.log("save, create new: ", this.editedPassenger);
                    await this.$store.dispatch('passenger/createPassenger', { data: this.editedPassenger });
                }
                this.editedPassenger = new Passenger(null);
                this.show = false;
            } catch (err) {
                vuetifyToast.error(
                    this.$i18n.translate(
                    'passenger.save.error.generic', 
                    'There was an error saving the passenger. Please try again later.'
                    )
                )
                console.error("Error when saving passenger:", err);
            }

        }
        this.saving = false;
    }

    onShowPassengerEditor(passenger: Passenger, data: any){
        this.editedPassenger = Passenger.CopyFrom(passenger);
        this.show = true;
    }

    onCloseClick() {
        // this.$emit("onClose", this.editedPassenger);
        this.editedPassenger = new Passenger(null);
        this.show = false;
    }

    beforeDestroy(){       
        this.$root.$off(PassengerEditor.EVENT_PASSENGER_EDITOR_OPEN, this.onShowPassengerEditor)
    }
}

export default PassengerEditor;
